import { render, staticRenderFns } from "./KisyaYoso.vue?vue&type=template&id=60bb9da5&scoped=true"
import script from "./KisyaYoso.vue?vue&type=script&lang=js"
export * from "./KisyaYoso.vue?vue&type=script&lang=js"
import style0 from "./KisyaYoso.vue?vue&type=style&index=0&id=60bb9da5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb9da5",
  null
  
)

export default component.exports